// extracted by mini-css-extract-plugin
export default {"pagebutton":"CalculateButton_pagebutton__Rz4UP","fancy_toggle_container":"CalculateButton_fancy_toggle_container__kVYuM","warning_message":"CalculateButton_warning_message__8jXi-"};